<template>
    <div class="bg-[#23242A] h-full overflow-y-auto">
        <div class="table-loading" v-if="loading">
            <block-loading />
        </div>
        <div class="p-3 custom-full custom-left" v-else-if="error"><p  class="text-center text-theme-red">Please select location</p></div>
        <div v-else>
            <div class="pt-[16px] px-[24px] max-w-full">
                <div class="flex justify-between shadow-xl box-border items-center text-white h-[62px] rounded p-4 bg-[#2B2C32] mb-4">
                    <div class="flex items-center">
                        <svg @click="goBack" class="cursor-pointer" width="20" height="20" vie wBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M20 8.75H4.7875L11.775 1.7625L10 0L0 10L10 20L11.7625 18.2375L4.7875 11.25H20V8.75Z" fill="white"/>
                        </svg>
                        <h1 class="font-bold ml-3 text-2xl leading-[30px] tracking-[0.05px]">New Inventory Transfer</h1>
                    </div>
                    <div class="flex items-center">
                        <div class="flex items-center border-r border-[#464851] pr-4">
                            <select v-model="form.status.value" class="cursor-pointer w-[200px] h-[40px] bg-[#464851] border-[#464851] focus:outline-0 font-normal text-base leading-5 text-white p-2 rounded">
                                <option value="pending">Pending</option>
                            </select>
                        </div>
                        <div class="flex items-center pl-4">
                            <button @click.prevent="goBack" class="flex justify-center items-center text-center w-[100px] h-[40px] p-4 border hover:border-theme-green text-[#9E9E9E] border-[#9E9E9E] hover:bg-theme-green hover:text-white rounded font-medium text-sm leading-[17.5px] tracking-[0.15px] mr-6">CANCEL</button>
                            <button @click.prevent="save" class="flex justify-center items-center text-center w-[100px] h-[40px] p-4  hover:opacity-60 bg-theme-green text-white rounded font-medium text-sm leading-[17.5px] tracking-[0.15px]">SAVE</button>
                        </div>
                    </div>
                </div>
            </div>
        
            <!-- Transfer details -->
            <div class=" px-[24px] max-w-full">
                <div class=" shadow-xl box-border items-center text-white rounded p-4 bg-[#2B2C32] mb-4">
                    <h2 class="font-bold  text-xl leading-6 tracking-[0.15px]">Transfer Details</h2>
                    <div class="flex gap-3 xl:flex-row flex-col items-start mt-[35px] mb-4">
                        <div class="w-full xl:w-1/2">
                            <div :class="'input-wrapper flex flex-col ' + (form.name.error_type)">
                                <label class="text-xs mb-1">Transfer Name *</label>
                                <input :disabled="$route.query.status==='shipped'" @keyup="validateFields(['name'])" v-model="form.name.value" placeholder="X-mas Quick Transfer" class="placeholder-[#9E9E9E] h-[40px] block border-none rounded bg-gray-black w-full text-sm text-theme-white" type="text">
                                <p class="field-error label-text mt-1" v-if="form.name.error_message" v-text="form.name.error_message"></p>
                            </div>
                        </div>
                        <div class="w-full xl:w-1/2">
                            <div :class="'input-wrapper flex flex-col ' + (form.fromLocationId.error_type)">
                                <label class="text-xs mb-1">Transfer From *</label>
                                <select :disabled="$route.query.status==='shipped'" @change="validateFields(['fromLocationId'])" v-model="form.fromLocationId.value" class="cursor-pointer w-full h-[40px] bg-[#464851] border-[#464851] focus:outline-0 font-normal text-base leading-5 text-white p-2 rounded">
                                    <option value="">Select a store</option>
                                    <option v-for="each in vg_locations" :key="each.id" :value="each.id">{{each.name}}{{ each.businessBrandProfile?.name ? ' [' + each.businessBrandProfile?.name + ']' : '' }}</option>
                                </select>
                                <p class="field-error label-text mt-1" v-if="form.fromLocationId.error_message" v-text="form.fromLocationId.error_message"></p>
                            </div>
                        </div>
                        <div class="w-full xl:w-1/2">
                            <div :class="'input-wrapper flex flex-col ' + (form.toLocationId.error_type)">
                                <label class="text-xs mb-1">Transfer To *</label>
                                <select :disabled="$route.query.status==='shipped'" @change="validateFields(['toLocationId'])" v-model="form.toLocationId.value" class="cursor-pointer w-full h-[40px] bg-[#464851] border-[#464851] focus:outline-0 font-normal text-base leading-5 text-white p-2 rounded">
                                    <option value="">Select a store</option>
                                    <template v-for="each in vg_locations">
                                        <option v-if="each.id!==form.fromLocationId.value" :key="each.id" :value="each.id">{{each.name}}{{ each.businessBrandProfile?.name ? ' [' + each.businessBrandProfile?.name + ']' : '' }}</option>
                                    </template>
                                </select>
                                <p class="field-error label-text mt-1" v-if="form.toLocationId.error_message" v-text="form.toLocationId.error_message"></p>
                            </div>
                        </div>
                        <div class="w-full xl:w-1/2">
                            <div class="input-wrapper flex flex-col ">
                                <p class="text-xs mb-1">Created On</p>
                                <div class="relative">
                                    <div class="absolute px-2 top-[10px]">
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M10 11.667C9.76389 11.667 9.56597 11.5871 9.40625 11.4274C9.24653 11.2677 9.16667 11.0698 9.16667 10.8337C9.16667 10.5975 9.24653 10.3996 9.40625 10.2399C9.56597 10.0802 9.76389 10.0003 10 10.0003C10.2361 10.0003 10.434 10.0802 10.5937 10.2399C10.7535 10.3996 10.8333 10.5975 10.8333 10.8337C10.8333 11.0698 10.7535 11.2677 10.5937 11.4274C10.434 11.5871 10.2361 11.667 10 11.667ZM6.66667 11.667C6.43056 11.667 6.23264 11.5871 6.07292 11.4274C5.91319 11.2677 5.83333 11.0698 5.83333 10.8337C5.83333 10.5975 5.91319 10.3996 6.07292 10.2399C6.23264 10.0802 6.43056 10.0003 6.66667 10.0003C6.90278 10.0003 7.10069 10.0802 7.26042 10.2399C7.42014 10.3996 7.5 10.5975 7.5 10.8337C7.5 11.0698 7.42014 11.2677 7.26042 11.4274C7.10069 11.5871 6.90278 11.667 6.66667 11.667ZM13.3333 11.667C13.0972 11.667 12.8993 11.5871 12.7396 11.4274C12.5799 11.2677 12.5 11.0698 12.5 10.8337C12.5 10.5975 12.5799 10.3996 12.7396 10.2399C12.8993 10.0802 13.0972 10.0003 13.3333 10.0003C13.5694 10.0003 13.7674 10.0802 13.9271 10.2399C14.0868 10.3996 14.1667 10.5975 14.1667 10.8337C14.1667 11.0698 14.0868 11.2677 13.9271 11.4274C13.7674 11.5871 13.5694 11.667 13.3333 11.667ZM10 15.0003C9.76389 15.0003 9.56597 14.9205 9.40625 14.7607C9.24653 14.601 9.16667 14.4031 9.16667 14.167C9.16667 13.9309 9.24653 13.733 9.40625 13.5732C9.56597 13.4135 9.76389 13.3337 10 13.3337C10.2361 13.3337 10.434 13.4135 10.5937 13.5732C10.7535 13.733 10.8333 13.9309 10.8333 14.167C10.8333 14.4031 10.7535 14.601 10.5937 14.7607C10.434 14.9205 10.2361 15.0003 10 15.0003ZM6.66667 15.0003C6.43056 15.0003 6.23264 14.9205 6.07292 14.7607C5.91319 14.601 5.83333 14.4031 5.83333 14.167C5.83333 13.9309 5.91319 13.733 6.07292 13.5732C6.23264 13.4135 6.43056 13.3337 6.66667 13.3337C6.90278 13.3337 7.10069 13.4135 7.26042 13.5732C7.42014 13.733 7.5 13.9309 7.5 14.167C7.5 14.4031 7.42014 14.601 7.26042 14.7607C7.10069 14.9205 6.90278 15.0003 6.66667 15.0003ZM13.3333 15.0003C13.0972 15.0003 12.8993 14.9205 12.7396 14.7607C12.5799 14.601 12.5 14.4031 12.5 14.167C12.5 13.9309 12.5799 13.733 12.7396 13.5732C12.8993 13.4135 13.0972 13.3337 13.3333 13.3337C13.5694 13.3337 13.7674 13.4135 13.9271 13.5732C14.0868 13.733 14.1667 13.9309 14.1667 14.167C14.1667 14.4031 14.0868 14.601 13.9271 14.7607C13.7674 14.9205 13.5694 15.0003 13.3333 15.0003ZM3.75 18.3337C3.41667 18.3337 3.125 18.2087 2.875 17.9587C2.625 17.7087 2.5 17.417 2.5 17.0837V4.16699C2.5 3.83366 2.625 3.54199 2.875 3.29199C3.125 3.04199 3.41667 2.91699 3.75 2.91699H5.10417V1.66699H6.45833V2.91699H13.5417V1.66699H14.8958V2.91699H16.25C16.5833 2.91699 16.875 3.04199 17.125 3.29199C17.375 3.54199 17.5 3.83366 17.5 4.16699V17.0837C17.5 17.417 17.375 17.7087 17.125 17.9587C16.875 18.2087 16.5833 18.3337 16.25 18.3337H3.75ZM3.75 17.0837H16.25V8.12533H3.75V17.0837ZM3.75 6.87533H16.25V4.16699H3.75V6.87533ZM3.75 6.87533V4.16699V6.87533Z" fill="white"/>
                                        </svg>
                                    </div>
                                    <input :disabled="true" v-model="todayDate"  placeholder="12/04/2023" class="placeholder-theme-878686 pl-[35px] h-[40px] block border-none rounded bg-gray-black w-full text-sm text-theme-white" type="text">
                                </div>
                            </div>
                        </div>
                    </div> 
                    <div class="flex gap-3 xl:flex-row flex-col items-start mt-[35px] mb-4">
                        <div class="w-full xl:w-1/4">
                            <div :class="'input-wrapper flex flex-col' ">
                                <label class="text-xs mb-1">ETA (optional)</label>
                                <div class="relative justify-center input-clear align-center">
                                    <svg
                                        width="16"
                                        class="absolute z-[99] left-[10px] bottom-[10px]"
                                        height="18"
                                        viewBox="0 0 16 18"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                        d="M8 10.6667C7.76389 10.6667 7.56597 10.5869 7.40625 10.4272C7.24653 10.2674 7.16667 10.0695 7.16667 9.83342C7.16667 9.5973 7.24653 9.39939 7.40625 9.23967C7.56597 9.07994 7.76389 9.00008 8 9.00008C8.23611 9.00008 8.43403 9.07994 8.59375 9.23967C8.75347 9.39939 8.83333 9.5973 8.83333 9.83342C8.83333 10.0695 8.75347 10.2674 8.59375 10.4272C8.43403 10.5869 8.23611 10.6667 8 10.6667ZM4.66667 10.6667C4.43056 10.6667 4.23264 10.5869 4.07292 10.4272C3.91319 10.2674 3.83333 10.0695 3.83333 9.83342C3.83333 9.5973 3.91319 9.39939 4.07292 9.23967C4.23264 9.07994 4.43056 9.00008 4.66667 9.00008C4.90278 9.00008 5.10069 9.07994 5.26042 9.23967C5.42014 9.39939 5.5 9.5973 5.5 9.83342C5.5 10.0695 5.42014 10.2674 5.26042 10.4272C5.10069 10.5869 4.90278 10.6667 4.66667 10.6667ZM11.3333 10.6667C11.0972 10.6667 10.8993 10.5869 10.7396 10.4272C10.5799 10.2674 10.5 10.0695 10.5 9.83342C10.5 9.5973 10.5799 9.39939 10.7396 9.23967C10.8993 9.07994 11.0972 9.00008 11.3333 9.00008C11.5694 9.00008 11.7674 9.07994 11.9271 9.23967C12.0868 9.39939 12.1667 9.5973 12.1667 9.83342C12.1667 10.0695 12.0868 10.2674 11.9271 10.4272C11.7674 10.5869 11.5694 10.6667 11.3333 10.6667ZM8 14.0001C7.76389 14.0001 7.56597 13.9202 7.40625 13.7605C7.24653 13.6008 7.16667 13.4029 7.16667 13.1667C7.16667 12.9306 7.24653 12.7327 7.40625 12.573C7.56597 12.4133 7.76389 12.3334 8 12.3334C8.23611 12.3334 8.43403 12.4133 8.59375 12.573C8.75347 12.7327 8.83333 12.9306 8.83333 13.1667C8.83333 13.4029 8.75347 13.6008 8.59375 13.7605C8.43403 13.9202 8.23611 14.0001 8 14.0001ZM4.66667 14.0001C4.43056 14.0001 4.23264 13.9202 4.07292 13.7605C3.91319 13.6008 3.83333 13.4029 3.83333 13.1667C3.83333 12.9306 3.91319 12.7327 4.07292 12.573C4.23264 12.4133 4.43056 12.3334 4.66667 12.3334C4.90278 12.3334 5.10069 12.4133 5.26042 12.573C5.42014 12.7327 5.5 12.9306 5.5 13.1667C5.5 13.4029 5.42014 13.6008 5.26042 13.7605C5.10069 13.9202 4.90278 14.0001 4.66667 14.0001ZM11.3333 14.0001C11.0972 14.0001 10.8993 13.9202 10.7396 13.7605C10.5799 13.6008 10.5 13.4029 10.5 13.1667C10.5 12.9306 10.5799 12.7327 10.7396 12.573C10.8993 12.4133 11.0972 12.3334 11.3333 12.3334C11.5694 12.3334 11.7674 12.4133 11.9271 12.573C12.0868 12.7327 12.1667 12.9306 12.1667 13.1667C12.1667 13.4029 12.0868 13.6008 11.9271 13.7605C11.7674 13.9202 11.5694 14.0001 11.3333 14.0001ZM1.75 17.3334C1.41667 17.3334 1.125 17.2084 0.875 16.9584C0.625 16.7084 0.5 16.4167 0.5 16.0834V3.16675C0.5 2.83341 0.625 2.54175 0.875 2.29175C1.125 2.04175 1.41667 1.91675 1.75 1.91675H3.10417V0.666748H4.45833V1.91675H11.5417V0.666748H12.8958V1.91675H14.25C14.5833 1.91675 14.875 2.04175 15.125 2.29175C15.375 2.54175 15.5 2.83341 15.5 3.16675V16.0834C15.5 16.4167 15.375 16.7084 15.125 16.9584C14.875 17.2084 14.5833 17.3334 14.25 17.3334H1.75ZM1.75 16.0834H14.25V7.12508H1.75V16.0834ZM1.75 5.87508H14.25V3.16675H1.75V5.87508ZM1.75 5.87508V3.16675V5.87508Z"
                                        fill="white"
                                        />
                                    </svg>
                                    <Datepicker :lower-limit="new Date()" v-model="(form.eta.value)" inputFormat="yyyy-MM-dd" :clearable="true" class="bg-theme-modalbg text-sm border-0 h-10 pl-[40px] w-full rounded placeholder:text-[#9E9E9E]" placeholder="Select a Date" />
                                </div>
                            </div>
                        </div>
                        <div class="w-full xl:w-1/4"></div>
                        <div class="w-full xl:w-1/4"></div>
                        <div class="w-full xl:w-1/4"></div>
                    </div>
                    <div class="flex xl:flex-row flex-col items-start mt-[35px] mb-4">
                        <div class="w-full ">
                            <div :class="'input-wrapper flex flex-col' ">
                                <label class="text-xs mb-1">Notes (optional)</label>
                                <textarea :disabled="$route.query.status==='shipped'" v-model="form.note.value" placeholder="Add a note here" class="placeholder:text-[#9E9E9E]  block border-none rounded bg-gray-black w-full text-sm text-theme-white" ></textarea>  
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {defineComponent, ref} from "vue";
import { mapGetters, mapActions, mapMutations } from "vuex";
import Helpers from '@/helpers';
import { useSnackbar } from "vue3-snackbar";
import TransferApi from '@/controllers/Transfer'
import ProductList from "@/views/Inventory/Transfer/transfer/ProductList.vue"
import SearchProduct from "@/views/Inventory/Transfer/transfer/SearchProduct.vue"
import Datepicker from 'vue3-datepicker'
import moment from 'moment'

export default defineComponent({
  name: "InventoryTransfer",
  components: {
    Datepicker,
    SearchProduct,
    ProductList,
  },

  setup() {
    const loading = ref(false)
    const error =ref(false)
    const snackbar = useSnackbar();
    const action = ref({
      component: '',
      data: [],
    });
    const payload = ref({transferProducts:[]})
    const form = ref({
      name: {
        value: '',
        error_type: '',
        error_message: '',
        validations: ['required', 'min:3'],
      },
      fromLocationId: {
        value: '',
        error_type: '',
        error_message: '',
        validations: ['required'],
      },
      toLocationId: {
        value: '',
        error_type: '',
        error_message: '',
        validations: ['required'],
      },
      eta: {
        value: null
      },
      note: {
        value: ''
      },
      status: {
        value: 'shipped'
      }
    });
    const todayDate = ref(null)
    const variantInfo = ref(false)
    const lotInfo =ref(false)
    const selected = ref([])

    return {
      loading,
      error,
      form,
      payload,
      snackbar,
      action,
      todayDate,
      variantInfo,
      lotInfo,
      selected
    };
  },

  computed: {
    /**
     * Edit restriction
     */
    can_edit_membership_details() {
      return Helpers.getMyPermission('can_edit_membership_details')
    },
    ...mapGetters({
        vg_locations: 'location/list',
    }),
  },
   watch: {
    'vg_selectedLocation'(val) {
      this.clearComponent();
    },
  },
 

  async mounted() {
    this.error = false
    if(this.$route.query.locationId){
        this.form.status.value = 'pending'
        this.form.fromLocationId.value = this.$route.query.locationId
        this.todayDate = moment().format('YYYY-MM-DD')
    }else{
        this.error = true
    }
  },

  watch: {
    "form.fromLocationId.value"(val){
        if(val===this.form.toLocationId.value){
            this.form.toLocationId.value = ''
        }
    }
  },

  methods: {
    async getData(){
        let res = await TransferApi.getTransfer(this.$route.params.id, this.$route.query.locationId)
        if(res.data?.payload){
            this.payload = res.data.payload
            this.form.name.value = this.payload.name
            this.form.fromLocationId.value = this.payload.fromLocationId
            this.form.toLocationId.value = this.payload.toLocationId
            this.form.eta.value = this.payload.eta?new Date(this.payload.eta):null
            this.form.note.value = this.payload.note
        }else{
            this.error = true
        }
    },
    goBack(){
        this.$router.push('/inventory-transfer')
    },
    async validateFields(fields) {
      let res = await Helpers.validateFormFields(this.form, fields);
      this.form = res.data;
      return res.error ? false : true;
    },
    async save(){
        let validate = await this.validateFields(['name', 'fromLocationId', 'toLocationId']);
        if(!validate) {
            return ;
        }
        this.va_spinner(true)
        let selectedFromLocation = this.vg_locations.find(each => each.id===this.form.fromLocationId.value)
        let selectedToLocation = this.vg_locations.find(each => each.id===this.form.toLocationId.value)
        let etaDate = this.form.eta.value?moment(this.form.eta.value).format('YYYY-MM-DD'):null
        let data = {
            name: this.form.name.value,
            fromLocationId: this.form.fromLocationId.value,
            fromLocationName: selectedFromLocation?selectedFromLocation.name:'',
            toLocationId: this.form.toLocationId.value,
            toLocationName: selectedToLocation?selectedToLocation.name:'',
            status: this.form.status.value,
            eta: etaDate,
            note: this.form.note.value
        }
        let res = await TransferApi.createTransfer(data)
        this.snackbar.add({
            type: 'info',
            text: res.status == 201 ? res.data.message : Helpers.catchErrorMessage(res.response.data),
            duration: 3000,
        })
        this.va_spinner(false)
        if(res.data?.payload?.id){
            this.$router.push({name: 'EditTransfer', params: {id: res.data.payload.id}, query: {locationId: this.form.fromLocationId.value, toLocationId: this.form.toLocationId.value,  status: 'pending'}})
        }
    },
    ...mapActions({
      va_spinner: "spinner/setSpinner",
    })
  },
});

</script>
<style>
.v3dp__datepicker{
    display: flex;
    flex-direction: row;
}
</style>
